import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
    >
      <div className="aspect-[3/4] overflow-hidden relative">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国漫画推荐`}
          title={`${comic.title} - 韩漫漫画网推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="bg-accent-500 text-background-50 text-xs font-medium px-2 py-1 rounded-md">
            {comic.rating}
          </span>
        </div>
        {comic.status === '已完结' && (
          <div className="absolute top-2 right-2">
            <span className="bg-foreground-800/80 text-background-50 text-xs px-2 py-1 rounded-md">
              已完结
            </span>
          </div>
        )}
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
          {comic.shortDescription}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
          <span>{comic.author}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(comic.views)}
          </span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {comic.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}